var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion112(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.33,
    height: 19.641,
    viewBox: "0 0 21.33 19.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_112",
    "data-name": "Union 112",
    d: "M13952.813,24577.857a5.976,5.976,0,0,1,.882-8.408l2.437-1.975a.75.75,0,1,1,.944,1.166l-2.437,1.975a4.478,4.478,0,1,0,5.639,6.959l2.437-1.975a.753.753,0,0,1,1.056.111.742.742,0,0,1-.111,1.055l-2.437,1.975a5.975,5.975,0,0,1-8.408-.883Zm14.188-.523-4.787-6.129-2.659,2.156a.75.75,0,0,1-.943-1.166l2.679-2.172-4.641-5.941a.749.749,0,1,1,1.178-.926l4.628,5.924,2.658-2.154a.754.754,0,0,1,1.055.111.74.74,0,0,1-.111,1.055l-2.678,2.17,4.807,6.152a.746.746,0,0,1-.13,1.049.734.734,0,0,1-.462.16A.747.747,0,0,1,13967,24577.334Zm.1-4.412a.751.751,0,0,1,.111-1.055l2.442-1.975a4.482,4.482,0,1,0-5.645-6.963l-2.437,1.973a.75.75,0,0,1-.944-1.166l2.437-1.973a5.982,5.982,0,0,1,7.533,9.295l-2.443,1.975a.752.752,0,0,1-.472.166A.744.744,0,0,1,13967.1,24572.922Z",
    transform: "translate(-13951.479 -24560.434)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion112);
export default __webpack_public_path__ + "static/media/Union112.65e3c3016eb9501ab4ac716b8d3409d1.svg";
export { ForwardRef as ReactComponent };